var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88705 2.43976C1.88705 2.36049 1.95131 2.29623 2.03058 2.29623H4.46584C4.76602 2.29623 5.00937 2.05289 5.00937 1.75271C5.00937 1.45252 4.76602 1.20918 4.46584 1.20918H2.03058C1.35095 1.20918 0.8 1.76013 0.8 2.43976V9.31028C0.8 9.98991 1.35095 10.5409 2.03058 10.5409H8.9011C9.58073 10.5409 10.1317 9.98991 10.1317 9.31028V6.87502C10.1317 6.57484 9.88834 6.33149 9.58815 6.33149C9.28797 6.33149 9.04463 6.57484 9.04463 6.87502V9.31028C9.04463 9.38955 8.98037 9.45381 8.9011 9.45381H2.03058C1.95131 9.45381 1.88705 9.38955 1.88705 9.31028V2.43976Z",
    fill: "#0073BC",
    stroke: "#0073BC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9519 0.906938C10.946 0.606814 10.698 0.368278 10.3979 0.374152L7.30671 0.434655C7.00658 0.440529 6.76805 0.688589 6.77392 0.988713C6.7798 1.28884 7.02786 1.52737 7.32798 1.5215L9.10719 1.48667L4.38588 6.39649L4.52928 6.53438L4.38588 6.39649C4.17781 6.61286 4.18455 6.95694 4.40092 7.16501C4.61729 7.37307 4.96137 7.36634 5.16944 7.14996L9.89074 2.24015L9.92557 4.01935C9.93144 4.31948 10.1795 4.55801 10.4796 4.55214C10.7797 4.54626 11.0183 4.29821 11.0124 3.99808L10.9519 0.906938Z",
    fill: "#3DA5E8",
    stroke: "#3DA5E8",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.5bd1a0ef6acb6ed4b4815ca8de8b3285.svg";
export { ForwardRef as ReactComponent };